var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"set_top_box"},[(_vm.getText)?_c('p',[_vm._v(_vm._s(_vm.getText))]):_vm._e(),_c('img',{attrs:{"src":_vm.getImg},on:{"click":_vm.setTop}})])}
var staticRenderFns = []

export { render, staticRenderFns }